export default "__VITE_ASSET__927b2cb9__"